import { CmmConfig } from '../../types/sharedTypeImpl.ts';
import { parsePositionNumber } from './parsePositionNumber.ts';
import { CmmPositionRead } from './types.ts';


export function readCmmPositions(
    table: string[][],
    cmmConfig: CmmConfig,
    firstRow: number,
    options?: { ignoreInvalidPosNr?: boolean }
): CmmPositionRead[] {
    const ignoreInvalidPosNr = options?.ignoreInvalidPosNr ?? false;

    const positions: CmmPositionRead[] = [];
    for (const row of table.slice(firstRow)) {
        const posNrRaw = row[cmmConfig.positionNumberColumn];
        const valueRaw = row[cmmConfig.positionValueColumn];
        if (!posNrRaw && !valueRaw) continue;//Skip empty rows

        const posNrParsed = posNrRaw ? parsePositionNumber(posNrRaw) : null;
        const posNrOk = posNrParsed != null;
        const posNr = posNrOk ? posNrParsed : posNrRaw;

        const valueParsed = valueRaw ? Number.parseFloat(valueRaw.replace(',', '.')) : null;
        const valueOk = valueParsed != null && !Number.isNaN(valueParsed);
        const value = valueOk ? valueParsed.toFixed(3) : valueRaw;

        if (!posNrOk && ignoreInvalidPosNr) continue;// Skip invalid position numbers if the option is set

        const issue = !valueOk ? 'Invalid value'
            : !posNrOk ? 'Invalid position number'
                : null;

        positions.push({
            positionNumber: posNr,
            value,
            ...(issue && { issue })
        });
    }
    return positions;
}

/**
 * Splits a flat list of positions into per-part groups.
 * A new part starts whenever a position number is seen again within the current group.
 */
export function splitIntoPartGroups(positions: CmmPositionRead[]): CmmPositionRead[][] {
    if (positions.length === 0) return [[]];

    const groups: CmmPositionRead[][] = [];
    let currentGroup: CmmPositionRead[] = [];
    const seenInCurrentGroup = new Set<string>();

    for (const pos of positions) {
        const posNr = typeof pos.positionNumber === 'string' ? pos.positionNumber : String(pos.positionNumber);
        if (posNr && seenInCurrentGroup.has(posNr)) {
            // Position number repeats → start a new part group
            groups.push(currentGroup);
            currentGroup = [pos];
            seenInCurrentGroup.clear();
            seenInCurrentGroup.add(posNr);
        } else {
            currentGroup.push(pos);
            if (posNr) seenInCurrentGroup.add(posNr);
        }
    }
    if (currentGroup.length > 0) {
        groups.push(currentGroup);
    }
    return groups;
}
